import { render, staticRenderFns } from "./ExternalTransmissionPolicy.vue?vue&type=template&id=6a140d9d&scoped=true&"
import script from "./ExternalTransmissionPolicy.vue?vue&type=script&lang=js&"
export * from "./ExternalTransmissionPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ExternalTransmissionPolicy.vue?vue&type=style&index=0&id=6a140d9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a140d9d",
  null
  
)

export default component.exports